<template>
  <div>
		<header-page
			name="page-edit-accounting"
			:title="$route.meta.title"
			:detail-journal-open="detailJournalOpen"
			:code-journal="codeDetailJournal"
			:date-journal="dateDetailJournal"
			:button-close="openMobile"
			tabindex="-1"
			@click-close="closeMobile"
		/>
		<div class="mt-4">
			<v-layout tabindex="-1">
				<v-flex>
					<v-alert class="my-0" :value="!currentSubsidiary.id" type="warning">
						Seleccione una empresa
					</v-alert>
				</v-flex>
			</v-layout>
			<v-layout wrap row align-center justify-end py-2 v-if="open">
				<v-flex xs4 md2 lg1 px-1 text-xs-center>
					<div class="content-blue font-weight-bold height-input px-2">
						DEBE: {{ sectionHeader.currencySymbol }} {{ sectionHeader.should }}
					</div>
				</v-flex>
				<v-flex xs4 md2 lg1 px-1 text-xs-center>
					<div class="content-red font-weight-bold height-input px-2">
						HABER: {{ sectionHeader.currencySymbol }} {{ sectionHeader.toHave }}
					</div>
				</v-flex>
				<v-flex xs4 md2 lg1 px-1 text-xs-center>
					<div class="content-gray font-weight-bold height-input px-2">
						SALDO: {{ sectionHeader.currencySymbol }} {{ sectionHeader.balance }}
					</div>
				</v-flex>
			</v-layout>
			<v-layout row wrap>
				<v-flex
				tabindex="-1"
				v-if="journalList && !openMobile"
				xs12 sm12 lg6 px-2 class="border-right">
					<app-table
						name="name-accounting"
						:rows="rows"
						:columns="columns"
						:main-list="false"
						:created-add="false"
					>
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columns, 1)">{{ props.row.code }}</td>
							<td v-show="showRow(columns, 2)" class="gloss">
								<p class="mb-0">
									<span class="desktop">Descripción:</span>
									<span v-if="props.row.gloss && !mobile">
										<span v-if="props.row.gloss.length < 17">
											{{props.row.gloss}}
										</span>
										<v-tooltip top v-else>
											<span slot="activator">{{ props.row.gloss | limitTo(17) }}</span>
											<span>{{ props.row.gloss }}</span>
										</v-tooltip>
									</span>
									<span v-else>{{ props.row.gloss }}</span>
								</p>
							</td>
							<td v-show="showRow(columns, 3)">{{ props.row.date | exactDate }}</td>
							<td v-show="showRow(columns, 4)">
								<app-tooltip-button
									class="state-radio"
									:color="statusColor(props.row)"
									icon="radio_button_checked"
									:text="statusName(props.row)"
								/>
							</td>
							<td v-show="showRow(columns, 5)">
								<app-tooltip-button
									img='/static/img/icons/detail-accouting.svg'
									text="Ver Detalle"
									class="mobile"
									:width="17"
									@click-icon="openDetailAccounting(props.row)"
								/>
								<div class="collapse-menu">
									<v-menu>
										<v-btn dark icon slot="activator">
											<v-icon>more_horiz</v-icon>
										</v-btn>
										<v-list>
											<v-list-tile class="btn-menu-content">
												<v-list-tile-title class="menu-content" @click="mobileDetail(props.row)">
													<img
													src="/static/img/icons/see-detail.svg"
													alt="icon-detail"
													width="15px"
													height="15px">
													<span class="ml-1 color-secondary">Ver detalle</span>
												</v-list-tile-title>
											</v-list-tile>
										</v-list>
									</v-menu>
								</div>
							</td>
						</template>
					</app-table>
				</v-flex>
				<v-flex
				class="content-detail"
				:class="{ 'open': openMobile }"
				xs12 sm12 lg6 px-2>
					<journal-detail
						:created-add="false"
						:accounts="accounts"
						:balance="sectionHeader.balance"
						:code-journal="codeJournal"
						:cost-centers="costCenters"
						:credit="credit"
						:debit="debit"
						:disabled-form-clean="disabledFormClean"
						:disabled-form-save="disabledFormSave"
						:not-declare="notDeclare"
						:to-declare="toDeclare"
						:open-detail-seat="openDetailSeat"
						:modules="modules"
						:accounting-account="accountingAccount"
						:subsidiary-id="params.subsidiaryId"
						:model-detail="modelDetail"
						tabindex="-1"
						:details="dataSelected"
						:edit-detail-inline="editDetailInline"
						:row-detail="rowDetail"
						:row-selected="rowSelected"
						@get-data="setDataDetail"
						@clean-all="cleanAll"
						@add-icon="createDetailSeat"
						@create-action="createDetailSeat"
						@add-detail-seat="addDetailSeat"
						@set-data-account="setData"
						@set-cost-center="setCostCenter"
						@add-detail="saveDetailSeat"
						@click-icon="onAction"
						@edit-detail-inline="inlineEditDetail"
						@on-click="onClick"
						@on-search="onSearchDetail"
						@save-all="onSaveMultiple"
						@set-model-data="setModelData"
					></journal-detail>
				</v-flex>
			</v-layout>
		</div>
		<action-sidebar
			:img-src="action.imgSrc"
			tabindex="-1"
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<journal-detail-delete-form
				v-if="action.code === 'delete'"
				:loading="loading"
				:name="rowDetailName"
				:seat-name="rowName"
				@close-modal="closeModal"
				@on-delete="onDelete"
			/>
			<journal-detail-form
				v-if="isActionCode('new-detail-seat')"
				:subsidiary-id="params.subsidiaryId"
				:model="model"
				@close-modal="closeModal"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import helper from '@/shared/helper';
import journalDetail from '@/components/journal/journal-detail';
import journalDetailTable from '@/components/journal/journal-detail-table';
import actionSidebar from '@/components/shared/action-sidebar';
import journalDetailDeleteForm from '@/components/journal/journal-detail-delete-form';
import journalDetailForm from '@/components/journal/journal-detail-form';
import { format } from 'date-fns';

const { exactDate } = helper;

function beforeDestroy() {
	window.removeEventListener('keydown', this.onKeyPress);
}

function created() {
	window.addEventListener('keydown', this.onKeyPress);
	window.addEventListener('resize', this.reziseMobile);
	this.reziseMobile();
	this.loadAccounting();
	if (this.currentSubsidiary.id) {
		this.setId(
			{ documentNumber: this.currentSubsidiary.documentNumber, id: this.currentSubsidiary.id },
			'subsidiaryId',
		);
	}
}

function reziseMobile() {
	const windowWidth = window.innerWidth;
	this.mobile = windowWidth <= 768;
}

function destroyed() {
	window.removeEventListener('resize', this.reziseMobile);
}

async function loadAccounting() {
	const params = {
		status: 3,
		subsidiaryId: this.$route.params.subsidiaryId,
		moduleCode: this.$route.params.moduleCode,
	};
	try {
		const response = await this.$http.get('accounting-seats', { params });
		this.rows = response.data;
	} catch (error) {
		this.showGenericError();
	}
}

async function saveDetailSeat() {
	this.dataSelected.push({
		...this.modelDetail,
		accountingAccount: this.accountingAccount,
		costCenter: this.costCenter,
	});
	const body = {
		accountingAccountId: this.modelDetail.accountingAccountId,
		account: this.modelDetail.account,
		amount: this.modelDetail.amount,
		concept: this.modelDetail.concept,
		reference: this.modelDetail.reference,
		costCenterId: this.modelDetail.costCenterId,
	};
	try {
		await this.$http.post(`/accounting-seat-details/${this.rowSelected.id}`, body);
		this.showNotification('Nuevo Detalle de Asiento guardo correctamente.');
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		};
		this.costCenter = {};
		this.accountingAccount = {};
		this.debit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) >= 0) {
				return a + Number(d.amount);
			}
			return a;
		}, 0);
		this.credit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) < 0) {
				return Number(d.amount) + a;
			}
			return a;
		}, 0);
		this.openDetailSeat = false;
	} catch (error) {
		this.showGenericError();
	}
}


function statusColor({ status }) {
	return status === 1 ? 'error' : 'success';
}
function statusName({ status }) {
	return status === 1 ? 'Pendiente' : 'Correcto';
}

async function openDetailAccounting(row) {
	this.selectSeat = row;
	this.rowDetail = {};
	this.rowSelected = { ...row };
	this.codeJournal = row.code;
	this.open = true;
	this.credit = row.totalHaber * -1;
	this.debit = row.totalDebe;
	this.toDeclare = Math.abs(this.credit) === Math.abs(this.debit);
	this.notDeclare = Math.abs(this.credit) !== Math.abs(this.debit);
	this.sectionHeader.currencySymbol = row.currency;
	this.sectionHeader.should = row.totalDebe;
	this.sectionHeader.toHave = row.totalHaber * -1;
	this.sectionHeader.balance = row.totalDebe - row.totalHaber;
	this.dataSelected = row.details ? row.details.map((detail) => {
		const newDetail = { ...detail };
		newDetail.accountingAccount = detail.accountingAccount || {};
		newDetail.amount = detail.amount || 0;
		newDetail.accountingAccount = detail.accountingAccount || {};
		newDetail.costCenter = detail.costCenter || {};
		return newDetail;
	}) : [];
	this.loadModules(row);
}

async function loadModules() {
	if (this.params.subsidiaryId) {
		({ data: this.modules } = await this.$http.get(
			`modules/${this.params.subsidiaryId}/subsidiary`));
		this.model.currency = this.isEcuador ? 'USD' : null;
		if (this.modules.length === 1 && !this.model.code) {
			this.moduleValue = this.modules[0];
			this.setModuleData(this.moduleValue);
		} else if (this.model.moduleCode) {
			this.moduleValue = this.modules.find(m => m.module.code === this.model.moduleCode);
			this.setModuleData(this.moduleValue);
		}
	} else {
		this.showNotification('Seleccione una empresa.', 'warning');
	}
}

async function loadAccounts() {
	const params = {
		status: 1,
	};
	({ data: this.accounts } = await this.$http.get(
		`accounting-plan/${this.params.subsidiaryId}/subsidiary`, { params }));
}

async function loadCostCenters() {
	({ data: this.costCenters } = await this.$http.get(
		`cost-center/${this.params.subsidiaryId}/subsidiary`));
}

function addDetailSeat() {
	this.openDetailSeat = !this.openDetailSeat;
}

function createDetailSeat() {
	this.action = {
		code: 'new-detail-seat',
		title: 'Nuevo detalle de asiento',
		value: true,
		open: true,
	};
}

async function subsidiaryChange(newSubsidiary) {
	if (newSubsidiary.id) {
		this.setId(
			{ documentNumber: newSubsidiary.documentNumber, id: newSubsidiary.id },
			'subsidiaryId',
		);
	} else {
		this.table.rows = [];
	}
}

function accountingName() {
	const account = this.accounts.find(acc => acc.account === this.model.account ||
		acc.code === this.model.account) || {};
	return account.name;
}

function setId({ documentNumber, id }, modelName) {
	if (modelName === 'subsidiaryId') {
		this.rucSubsidiary = documentNumber;
	}
	this.params[modelName] = id;
	this.loadAccounts();
	this.loadModules();
	this.loadCostCenters();
}

function setData(value) {
	this.accountingAccount = { ...value };
	this.modelDetail.account = value.code;
	this.modelDetail.accountingAccountId = value.id;
}

function onAction({ action, row }) {
	const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	if (reg.test(navigator.userAgent) || action === 'delete') {
		const seat = this.rows.find(r => r.id === row.accountingSeatId) || {};
		this.rowId = seat.id;
		this.rowName = seat.gloss;
		this.params.subsidiaryId = seat.subsidiaryId;
		this.rowDetailId = row.id;
		this.rowDetailName = row.accountingAccount.name;
		this.action.width = 400;
		this.action.code = action;
		if (action === 'new-detail-seat') {
			if (this.model) {
				this.onClick(row);
				this.action.title = 'Editar Detalle';
				this.model.accountingAccountId = row.accountingAccountId;
			}
		} else if (action === 'delete') {
			this.action.title = 'Eliminar Detalle';
			this.rowAccouting = seat;
		}
		this.action.value = true;
	} else {
		this.editDetailInline = true;
		this.modelDetail = { ...row };
		this.dataSelected = this.dataSelected.map((ds) => {
			const newDataSelected = { ...ds };
			newDataSelected.onEdit = row.id === ds.id;
			return newDataSelected;
		});
		setTimeout(() => {
			const focusDetailEdit = document.getElementById('focus-edit-inline');
			focusDetailEdit.click();
		}, 1000);
	}
}

function onKeyPress(event) {
	const ctrlKeyPressed = event.ctrlKey;
	const altKeyPressed = event.altKey;
	const lKeyPressed = event.code === 'KeyL';
	const eKeyPressed = event.code === 'KeyE';
	const keyAccess = ctrlKeyPressed && altKeyPressed && lKeyPressed;
	const keyAccessEdit = ctrlKeyPressed && altKeyPressed && eKeyPressed;
	if (keyAccess) {
		this.createAction();
	}
	if (keyAccessEdit) {
		this.onAction({ row: this.dataSelected[0] });
	}
	if (event.code === 'Escape') {
		this.editDetailInline = false;
		this.model = {
			code: '',
			currency: '',
			date: null,
			gloss: '',
			moduleCode: '',
			ruc: '',
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		};
		this.dataSelected = this.dataSelected.map((ds) => {
			const newDataSelected = { ...ds };
			newDataSelected.onEdit = false;
			return newDataSelected;
		});
	}
}

async function inlineEditDetail({ id }) {
	const body = {
		account: this.modelDetail.account,
		accountingAccountId: this.modelDetail.accountingAccountId,
		amount: this.modelDetail.amount,
		concept: this.modelDetail.concept,
		costCenterId: this.modelDetail.costCenterId,
		reference: this.modelDetail.reference,
	};
	try {
		await this.$http.patch(
			`accounting-seat-details/${this.modelDetail.accountingSeatId}/${this.modelDetail.id}`,
			body,
		);
		this.dataSelected = this.dataSelected.map((ds) => {
			const newDataSelected = { ...ds };
			newDataSelected.account = id === ds.id ? this.modelDetail.accountingAccount.code :
				ds.account;
			newDataSelected.accountingAccount = id === ds.id ?
				this.modelDetail.accountingAccount : ds.accountingAccount;
			newDataSelected.accountingAccountId = id === ds.id ?
				this.modelDetail.accountingAccount.id : ds.accountingAccountId;
			newDataSelected.amount = id === ds.id ? this.modelDetail.amount : ds.amount;
			newDataSelected.concept = id === ds.id ? this.modelDetail.amount : ds.concept;
			newDataSelected.costCenter = id === ds.id ? this.modelDetail.costCenter :
				ds.costCenter;
			newDataSelected.costCenterId = id === ds.id ? this.modelDetail.costCenter.id :
				ds.costCenterId;
			newDataSelected.reference = id === ds.id ? this.modelDetail.reference :
				ds.reference;
			if (newDataSelected.amount > 0) {
				newDataSelected.amountDebe = id === ds.id ? this.modelDetail.amount :
					ds.amountDebe;
				newDataSelected.amountHaber = id === ds.id ? 0 : ds.amountHaber;
				newDataSelected.type = id === ds.id ? 1 : ds.type;
			} else {
				newDataSelected.amountHaber = id === ds.id ? this.modelDetail.amount :
					ds.amountHaber;
				newDataSelected.amountDebe = id === ds.id ? 0 : ds.amountDebe;
				newDataSelected.type = id === ds.id ? 2 : ds.type;
			}
			newDataSelected.onEdit = false;
			return newDataSelected;
		});
		this.showNotification('Detalle de asiento editado correctamente');
		this.editDetailInline = false;
		this.model = {
			code: '',
			currency: '',
			date: null,
			gloss: '',
			moduleCode: '',
			ruc: '',
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		};
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function setCostCenter(value) {
	this.costCenter = { ...value };
	this.modelDetail.costCenterId = value.id;
}

function onClick(row) {
	this.loadCostCenters(row);
	this.setModel('detail', row);
	this.selectDetail(row);
}

function setModel(type, row) {
	if (type === 'heading') {
		this.model.code = row.code;
		this.model.date = exactDate(row.date, 'YYYY-MM-DD');
		this.model.gloss = row.gloss;
		this.model.moduleId = row.moduleId || row.typeRegister.id;
		this.model.ruc = row.ruc;
		this.model.account = null;
		this.model.accountingAccount = {};
		this.model.amount = null;
		this.model.concept = null;
		this.model.costCenterId = null;
		this.model.reference = null;
		this.params.subsidiaryId = row.subsidiaryId;
	} else {
		this.model.account = row.account;
		this.model.accountingAccount = row.accountingAccount;
		this.model.amount = row.amount;
		this.model.concept = row.concept;
		this.model.costCenterId = row.costCenterId;
		this.model.reference = row.reference;
	}
}

function selectDetail(row) {
	this.rowDetail = { ...row };
	this.dataSelected = this.dataSelected.map((d) => {
		const newRow = { ...d };
		newRow.isSelected = d.id === row.id;
		return newRow;
	});
	this.dataSelectedOriginal = this.dataSelectedOriginal.map((d) => {
		const newRow = { ...d };
		newRow.isSelected = d.id === row.id;
		return newRow;
	});
}

function disabledFormClean() {
	const modelKeys = Object.keys(this.model);
	const modelDetailKeys = Object.keys(this.modelDetail);
	return modelKeys.every(mk => !this.model[mk]) && modelDetailKeys.every(mdk =>
		!this.modelDetail[mdk]);
}

function disabledFormSave() {
	return !this.model.moduleCode || !this.model.gloss || !this.model.date ||
		this.dataSelected.length === 0;
}

function setDataDetail({ model, value }) {
	this.modelDetail[model] = value;
	if (model === 'accountingAccount') {
		this.modelDetail.account = value.code;
		this.modelDetail.accountingAccountId = value.id;
	}
	if (model === 'costCenter') {
		this.modelDetail.costCenterId = value.id;
	}
}

function cleanAll() {
	this.model = {
		code: '',
		currency: '',
		date: null,
		gloss: '',
		moduleCode: '',
		ruc: '',
	};
	this.modelDetail = {
		accountingAccountId: null,
		account: null,
		concept: '',
		reference: '',
		costCenterId: null,
		amount: 0,
	};
	this.dataSelected = [];
	this.sectionHeader = {
		balance: null,
		currencySymbol: null,
		should: null,
		toHave: null,
	};
	this.debit = null;
	this.credit = null;
	this.notDeclare = false;
}

function onSearchDetail(value) {
	const localSearch = value ? value.trim() : '';
	if (value.length) {
		this.dataSelected = [...this.dataSelectedOriginal];
		const rowsFilter = this.dataSelected.filter(item =>
			(item.account.toLowerCase().indexOf(localSearch.toLowerCase()) > -1));
		this.dataSelected = rowsFilter;
	} else {
		this.dataSelected = [...this.dataSelectedOriginal];
	}
}

async function onSaveMultiple() {
	const body = {
		accountingAccountDetail: this.dataSelected.map(detail => ({
			accountingAccountId: detail.accountingAccountId,
			account: detail.account,
			amount: detail.amount,
			concept: detail.concept,
			costCenterId: detail.costCenterId,
			reference: detail.reference,
		})),
		currency: this.isEcuador ? 'USD' : 'PEN',
		date: format(this.model.date, 'YYYY-MM-DD'),
		gloss: this.model.gloss,
		moduleCode: this.model.moduleCode,
		ruc: this.rucSubsidiary,
	};
	try {
		await this.$http.post(
			'accounting-seats/multiple_details', body);
		this.showNotification('El asiento y los detalles han sido creados correctamente.');
		await this.loadData('accounting-seats');
		this.seeDetail(this.rows[0]);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function setModelData({ model, value }) {
	if (model === 'date' || model === 'gloss') {
		this.model[model] = value;
	} else {
		this.modelDetail[model] = value;
	}
}

async function onDelete() {
	this.loading = true;
	try {
		await this.$http.delete(`accounting-seat-details/${this.rowDetailId}`);
		this.showNotification('El detalle de asiento ha sido eliminado correctamente.');
		this.closeModal();
		// this.openDetailAccounting(this.rowAccouting);
		this.cleanAll();
		this.loadAccounting();
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		this.loading = false;
	}
}

function closeModal() {
	this.action.value = false;
	this.action.title = '';
	this.action.code = '';
}

function isActionCode(code) {
	return this.action.code === code;
}

function mobileDetail(row) {
	this.detailJournalOpen = true;
	this.codeDetailJournal = row.code;
	this.dateDetailJournal = exactDate(row.date, 'YYYY-MM-DD');
	const index = this.rows.findIndex(t => t.id === row.id);
	if (index > -1) {
		this.dataSelected = this.rows[index].details ?
			this.rows[index].details.map((detail) => {
				const newDetail = { ...detail };
				newDetail.accountingAccount = detail.accountingAccount || {};
				newDetail.amount = detail.amount || 0;
				newDetail.accountingAccount = detail.accountingAccount || {};
				newDetail.costCenter = detail.costCenter || {};
				return newDetail;
			}) : [];
		this.dataSelectedOriginal = [...this.dataSelected];
		this.rowIdSeat = this.rows[index].id;
		this.credit = this.rows[index].totalHaber * -1;
		this.debit = this.rows[index].totalDebe;
		this.seccionHeader.currencySymbol = this.currencySymbol(this.rows[index]);
		this.seccionHeader.should = this.rows[index].totalDebe;
		this.seccionHeader.toHave = this.rows[index].totalHaber * -1;
		this.seccionHeader.balance =
			this.rows[index].totalDebe - this.rows[index].totalHaber;
		if (this.credit === this.debit) {
			this.toDeclare = true;
		} else {
			this.notDeclare = true;
		}
		this.openMobile = true;
	}
}

function currencySymbol(rowSelected) {
	return rowSelected.currency === 'PEN' ? 'S/.' : null;
}

function closeMobile() {
	this.detailJournalOpen = false;
	this.openMobile = false;
}

function data() {
	return {
		accountingAccount: {},
		accounts: [],
		columns: [
			{
				id: 1,
				name: 'Asiento',
				value: 'accouting',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Descripción',
				value: 'accouting',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'Fecha',
				value: 'accouting',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Estado',
				value: 'accouting',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Acciones',
				value: 'action',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		columnsDetail: [
			{
				id: 1,
				name: 'Cód. Cta.',
				value: 'code',
				checked: true,
				visible: true,
			},
			{
				id: 2,
				name: 'Cuenta Cta.',
				value: 'accouting',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'Referencia',
				value: 'reference',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Concepto de mov',
				value: 'concept',
				checked: true,
				visible: true,
			},
			{
				id: 5,
				name: '',
				value: '',
				checked: true,
				visible: true,
			},
			{
				id: 6,
				name: 'Importe',
				value: 'import',
				checked: true,
				visible: true,
			},
			{
				id: 7,
				name: 'Centro de costo',
				value: 'centerOfCost',
				checked: true,
				visible: true,
			},
			{
				id: 8,
				name: 'Acciones',
				value: 'actions',
				checked: true,
				visible: true,
			},
		],
		codeDetailJournal: null,
		costCenters: [],
		codeJournal: null,
		credit: 0,
		dateDetailJournal: null,
		dataSelectedOriginal: [],
		detailJournalOpen: false,
		debit: 0,
		editDetailInline: false,
		journalList: true,
		modelDetail: {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		},
		model: {
			code: '',
			currency: '',
			date: null,
			gloss: '',
			moduleCode: '',
			ruc: '',
		},
		modules: [],
		notDeclare: false,
		rows: [],
		dataSelected: [],
		open: false,
		rowSelected: {},
		rowDetail: {},
		toDeclare: false,
		openDetailSeat: false,
		sectionHeader: {
			currencySymbol: null,
			should: null,
			toHave: null,
			balance: null,
		},
		action: {
			code: '',
			title: '',
			value: false,
		},
		rowAccouting: {},
		rowDetailName: '',
		rowName: '',
		openMobile: false,
		loading: false,
		rowDetailId: null,
		selectSeat: null,
	};
}

export default {
	name: 'page-edit-accounting',
	beforeDestroy,
	data,
	created,
	destroyed,
	components: {
		appTooltipButton,
		journalDetailTable,
		journalDetail,
		journalDetailForm,
		actionSidebar,
		journalDetailDeleteForm,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		accountingName,
		disabledFormClean,
		disabledFormSave,
	},
	methods: {
		addDetailSeat,
		cleanAll,
		closeMobile,
		createDetailSeat,
		currencySymbol,
		inlineEditDetail,
		isActionCode,
		loadModules,
		loadAccounts,
		loadCostCenters,
		mobileDetail,
		onSaveMultiple,
		onSearchDetail,
		reziseMobile,
		saveDetailSeat,
		setModel,
		setModelData,
		setCostCenter,
		setId,
		selectDetail,
		statusColor,
		statusName,
		setDataDetail,
		subsidiaryChange,
		loadAccounting,
		onAction,
		onClick,
		onKeyPress,
		openDetailAccounting,
		setData,
		onDelete,
		closeModal,
	},
	watch: {
		currentSubsidiary: subsidiaryChange,
	},
};
</script>

<style lang="scss" scoped>
.content-open {
	background-color: #e0e5e8;
	font-weight: 700;
	padding: 5px 0;
}

.content-blue {
	border: 1px solid map-get($colors, secondary);
	color: map-get($colors, white);
	font-size: map-get($sizes, small);
}

.content-gray {
	background-color: map-get($colors, grey-icon);
	color: map-get($colors, white);
	font-size: 12px;
}

.content-red {
	border: 1px solid map-get($colors, red-icon);
	color: map-get($colors, white);
	font-size: map-get($sizes, small);	
}

.border-right {
	border-right: 5px solid #a9bac2;
}


.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/5;
		grid-row: 2;
		white-space: nowrap;
	}
}

.collapse-menu {
	display: none;

	@media (max-width: 768px) {
		align-items: center;
		display: block;
		grid-column: 4/5;
		grid-row: 1;
		height: 100%;
		justify-content: center;

		.v-menu {
			align-items: center;
			display: flex;
			height: 100%;
			justify-content: center;

			.v-btn {
				background-color: color(btn-green);
				height: 25px;
				margin: 0;
				width: 25px;
			}
		}
	}
}

.color-secondary {
	color: map-get($colors, secondary);
	font-family: map-get($fonts, AvenirRegular);
	font-size: map-get($sizes, small11);
}

.content-detail {
	@media (max-width: 768px) {
		left: -100%;
		position: absolute;
		transition: all .2s ease-in-out 0s;
		z-index: 2;

		&.open {
			left: 0;
		}
	}
}

.state-radio {
	position: relative;
	bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/accounting-periods/page-edit-accounting.vue